import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './CurrentTrainingSkeleton.styles';

function CurrentTrainingSkeleton() {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <>
      <Box className={classes.headerWrapper}>
        <Box className={classes.titleRow}>
          <Skeleton
            variant="text"
            className={classes.titleSkeleton}
            height={36}
          />
          <Skeleton
            variant="circular"
            className={classes.editIconSkeleton}
            width={40}
            height={40}
          />
        </Box>
        <Skeleton
          variant="text"
          className={classes.dateSkeleton}
          height={24}
          width="40%"
        />
      </Box>

      {[1, 2].map((i) => (
        <Box key={i} className={classes.setGroupSkeleton}>
          <Skeleton
            variant="text"
            className={classes.setGroupTitle}
            height={28}
            width="70%"
          />
          <Skeleton variant="rectangular" height={48} />
          <Box className={classes.setRow}>
            <Skeleton variant="text" height={24} width="30%" />
            <Skeleton variant="text" height={24} width="20%" />
          </Box>
        </Box>
      ))}

      <Skeleton
        variant="rectangular"
        className={classes.addBlockSkeleton}
        height={48}
      />

      <Skeleton
        variant="rectangular"
        className={classes.buttonSkeleton}
        height={44}
        width={160}
      />
    </>
  );
}

export default CurrentTrainingSkeleton;
